import React from "react";
import {
  Row,
  Col,
  Input,
  Tag,
  Avatar,
  Button,
  Space,
  Dropdown,
  Popconfirm,
  message,
  Tooltip,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import ShareModalWindow from "./ShareModalWindow";
import dayjs from "dayjs";
import {
  PushpinFilled,
  EditFilled,
  DeleteFilled,
  QuestionCircleOutlined,
  DownOutlined,
  SearchOutlined,
  DownloadOutlined,
  CloudUploadOutlined,
  DashboardOutlined,
  PlusOutlined,
  CarOutlined,
  CopyOutlined,
  ShareAltOutlined,
  FacebookOutlined,
  TwitterOutlined,
  MailOutlined,
  SkypeOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import AddButton from "./AddButton";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import withRouter from "../withRouter";

import AssignJobOrderStore from "../store/AssignJobOrderStore";
import CompanyStore from "../store/CompanyStore";
import AssignBusToStudent from "./AssignBusToStudent";
import Icon from "react-multi-date-picker/components/icon";

class AssignJobOrderList extends React.Component {
  constructor(props) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.onDelete = this.onDelete.bind(this);

    this.assignJobOrderStore = new AssignJobOrderStore();

    // console.log(this.context);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      company_value_label: "",
      openShareModal: false,
    };
    this.menuProps = {
      items: [
        {
          label: "Sample Excel",
          key: "1",
          icon: <DownloadOutlined />,
        },
        {
          label: "Upload",
          key: "2",
          icon: <CloudUploadOutlined />,
        },
        {
          label: "Dashboard",
          key: "2",
          icon: <DashboardOutlined />,
        }
      ],
      onClick: () => {},
    };
  }
  async componentDidMount() {
    this.setState({ pageSize: 50 });
  
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
     
      this.setState(
        { companyId: this.props.getUserData().userCompanyId },
        () => this.handleSearch()  // RUN AFTER STATE UPDATED
      );
    }


    const singleData = await this.companyStore.getCompanyDataById(
      this.context.viewStateStore.assignTripObject.companyId
    );
    await this.setState({ loadList: 1 }); //need to reload data
    await this.setState({ company_value_label: singleData });

    this.columns = [
      {
        // title: "Trip Code",
        title: this.context.translate("_JOB_ORDER_ID_"),
        // width: 150,
        dataIndex: "stId",
        key: "stId",
        render: (val, record) => {
          if (record.isNew == 1) {
            // Editable job order → show Link
            return (
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {val}
              </Link>
            );
          }

          // Not editable → show plain text
          return <span>{val}</span>;
        },
        // fixed: "left",
      },
      {
        // title: "Trip Name",
        title: this.context.translate("_CREATED_ON_"),
        // width: 150,
        dataIndex: "createDate",
        key: "createDate",
        // fixed: "left",
      },
      {
        // title: "Zone Details",
        title: this.context.translate("_JOB_ORDER_START_DATE_"),
        // width: 150,
        dataIndex: "routestartDate",
        key: "routestartDate",
        render: (_, record) => {
          return record.routestartDate
            ? dayjs(record.routestartDate, "YYYY-MM-DD HH:mm:ss").format(
              "DD-MM-YYYY hh:mm A"
            )
            : "";
        }
      },
      {
        // title: "Vehicle No",
        title: this.context.translate("_JOB_ORDER_END_DATE_"),
        // width: 150,
        dataIndex: "routestopDate",
        key: "routestopDate",
       render: (_, record) => {
      return record.routestopDate
        ? dayjs(record.routestopDate, "YYYY-MM-DD HH:mm:ss").format(
            "DD-MM-YYYY hh:mm A"
          )
        : "";
       }
      },
      {
        // title: "Seater",
        title: this.context.translate("_UNIT_"),
        // width: 150,
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        render: (_, record) => {
          if (record.vehicleNo && record.operationalCardNo) {
            return `${record.vehicleNo} / ${record.operationalCardNo}`;
          }
          return record.vehicleNo;
        }
      },
      {
        // title: "Available Seats",
        title: this.context.translate("_DRIVERS_"),
        // width: 150,
        dataIndex: "driverName",
        key: "driverName",
        // fixed: "left",
      },

      {
        title: this.context.translate("_ACTION_"),
        dataIndex: "Action",
        // key: "Action",
        fixed: "right",
        // width: 50,
        render: (_, record) => {
          let tripPoints = record.RoutePoints;
          let data = [];
          tripPoints.forEach((val) =>
            data.push(`${val.latitude},${val.longitude}`)
          );

          return (
            <>
              <Space>
                <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete Trip Details"
                      title={this.context.translate("_DELETE_TRIP_DETAILS_")}
                      color={config.tooltipColorDelete}
                      placement="bottom"
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm>
              </Space>
            </>
          );
        }
      }
    ];
  }
  onEdit = async (record) => {
    console.log(record);
    const stId = record.stId;
    await this.context.viewStateStore.setAssignJobOrderStates({
      companyId: record.companyId,
    });
    if (stId) {
      this.props.navigate("/assignjoborderaddnew/" + stId);
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    console.log(comp);
    // await this.assignJobOrderStore.loadData(comp.value)
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);
    await this.setState({ company_value_label: singleData });

    await this.setState({ loadList: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.assignJobOrderStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {
    console.log(record);
    const response = await this.assignJobOrderStore.deleteJobOrder({
      stId: record.stId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  render() {
    console.log("in render");
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FLEET_DASHBORD_NAVIRIGHT_JOBORDER_")}
                {/* Create/Assign Trip Details */}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  placement="left"
                  title="Add"
                  color={config.primaryColor}
                >
                  {/* <AddButton
                    type="primary"
                    className="addButton"
                    icon={<PlusOutlined />}
                    link="/assigntripadd"
                  /> */}

                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => this.props.navigate("/assignjoborderaddnew")}
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div>

        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {/* <div style={{padding:"24px"}}> */}
          {/* <div className='heading'>Create/Assign Trip Details</div> */}
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : ""
                  }
                  // allowClear={true}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            {/* <Col span={8}>
                  <Space style={{float:this.context.locale.direction=="ltr"?"right":"left"}}> 
                    <AddButton title={this.context.translate('_ADD_')} link ="/assigntripaddnew" />
                    
                  </Space>
                </Col> */}
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.assignJobOrderStore?.total}
            columns={this.columns}
            dataSource={this.assignJobOrderStore?.jobDataArray}
            loading={this.assignJobOrderStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openShareModal && (
          <ShareModalWindow
            shareLink={this.state.openShareModal}
            shareModalCloseFunc={(resp) =>
              this.setState({ openShareModal: resp })
            }
            shareModalVisible={this.state.openShareModal}
          />
        )}
      </>
    );
  }
}
AssignJobOrderList.contextType = StoreContext;
export default observer(withRouter(AssignJobOrderList));

//
